import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Col } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png';
import dtvLogo from './img/dtv-logo-blue.svg';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const nodeRef = useRef();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    const encodedPassword = encodeURIComponent(password);

    api.userPassLogin(
      {
        username,
        password: encodedPassword,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-montevideoportal-container" ref={nodeRef}>
        <h1 className="login-title">Ingresar</h1>

        <div className="login-montevideoportal-header">
          <div className="logos-container">
            <img src={logo} alt="Montevideo Portal" className="logo-montevideoportal" />
            <div className="logo-separator"></div>
            <img src={dtvLogo} alt="DirecTV" className="logo-dtv" />
          </div>
        </div>

        <div className="login-montevideoportal-body">
          <Form onSubmit={event => onSubmit(event)}>
            <Col className="form-group">
              <Input
                className="input-montevideoportal"
                disabled={onLogin}
                required={true}
                tabIndex={1}
                type="email"
                autoCorrect="off"
                autoCapitalize="none"
                id="username"
                placeholder="E-mail"
                onChange={e => setUsername(e.target.value)}
              />
            </Col>

            <Col className="form-group">
              <Input
                className="input-montevideoportal"
                required={true}
                disabled={onLogin}
                tabIndex={2}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                id="password"
                placeholder="Contraseña"
                onChange={e => setPassword(e.target.value)}
              />
              <a href="https://autogestion2.montevideocomm.uy/autogestion/servlet/adtv_campassp1" className="forgot-link">{translate("ForgotPassword")}</a>
            </Col>

            {!onLogin ? (
              <div className="button-container">
                <button
                  tabIndex={3}
                  className="enter-montevideoportal"
                  type="submit"
                  name="submit"
                  disabled={!props.turnstileSuccess}
                >
                  Ingresar
                </button>
              </div>
            ) : (
              <Progress animated color="danger" value={100} />
            )}

            <div className="messages-container">
              <Alert color="danger" id="error-message" isOpen={error.open} toggle={() => setError({ open: false })}>
                {error.message}
              </Alert>
            </div>
          </Form>
        </div>
        <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
